// extracted by mini-css-extract-plugin
module.exports = {"price":"VE-z","onSale":"WE-z"};